export const SITE = {
  name: "爆料直播",
  englishName: "BAOLIAO LIVE",
  legalName: "爆料直播·现场资讯中心",
  slogan: "现场实时画面 · 突发事态直击",
  subSlogan: "直播镜头追踪不停歇，实时画面信号稳定，还能听到现场连麦声音。",
  url: "https://fzhome.com.cn",
  logoText: "爆料",
  logoAccent: "直播",
  email: "contact@baoliaozhibo.com",
  tipEmail: "tip@baoliaozhibo.com",
  serviceHours: "全年无休 · 现场信号 24 小时值守",
  onlineSignals: "12 路信号在线",
  founder: "现场信号编辑组",
  since: "2021",
  orgDesc:
    "爆料直播是聚焦第一现场的直播资讯聚合平台，以现场实时画面与突发事态直击为核心内容形态。",
};

export interface NavLinkItem {
  label: string;
  to: string;
  desc: string;
}

export const NAV_LINKS: NavLinkItem[] = [
  { label: "首页", to: "/", desc: "回到爆料直播首页" },
  { label: "直播大厅", to: "/live", desc: "查看全部现场与信号状态" },
  { label: "关于我们", to: "/about", desc: "了解爆料直播的定位与原则" },
  { label: "常见问题", to: "/faq", desc: "观看、连麦与信号答疑" },
];